import { z } from 'zod';

import { requiredString } from '@utils/validation';

export const dataConstants = {
	DLN: 'dln',
};

export const testContent = {
	dl_input_label: "Driver's license number",
};

export const schema = z.object({
	[dataConstants.DLN]: requiredString("Please provide a valid driver's license number"),
});
